module.exports = __webpack_public_path__ + "img/view-marks.8377b9a4.svg";